import { useMemo } from "react";

import { useUser } from "@components/user-context";

export const useIsAutoblessedModelsEnabled = () => {
  const { user } = useUser();

  const isEnabled = user.featureFlags.enableMMMAutoblessedModels;
  return isEnabled;
};
